/* ========================================
   Accordion Stack 2026 - Interactive Logic
   ======================================== */

(function() {
  'use strict';

  class AccordionStack {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll('[data-accordion-item]'));
      this.finalItem = this.items.find(item => item.hasAttribute('data-final-item'));
      this.handleResize = this.refreshExpandedHeights.bind(this);
      this.init();
    }

    init() {
      if (this.items.length === 0) return;

      this.items.forEach((item, index) => {
        const trigger = item.querySelector('.accordion-stack-2026__trigger');
        const content = item.querySelector('[data-accordion-content]');
        const iconLinkElement = item.querySelector('[data-icon-link]');
        
        if (trigger) {
          trigger.addEventListener('click', (e) => this.handleTriggerClick(e, item));
        }

        if (iconLinkElement) {
          iconLinkElement.addEventListener('click', (e) => this.handleIconLinkClick(e, iconLinkElement));
        }
        
        if (content && !item.hasAttribute('data-final-item')) {
          content.addEventListener('click', (e) => this.handleContentClick(e, item));
        }
      });

      // Default: expand last block and collapse others
      this.collapseAll();
      if (this.finalItem) {
        this.expandItem(this.finalItem);
      }

      this.bindImageLoadAdjustments();
      window.addEventListener('resize', this.handleResize);
    }

    handleTriggerClick(e, item) {
      const iconLinkElement = item.querySelector('[data-icon-link]');
      if (iconLinkElement) {
        const iconRect = iconLinkElement.getBoundingClientRect();
        const clickedIconArea =
          e.clientX >= iconRect.left &&
          e.clientX <= iconRect.right &&
          e.clientY >= iconRect.top &&
          e.clientY <= iconRect.bottom;

        if (clickedIconArea) {
          const iconLink = iconLinkElement.getAttribute('data-icon-link');
          if (iconLink) {
            e.preventDefault();
            window.location.assign(iconLink);
            return;
          }
        }
      }
      e.preventDefault();
      
      // Click on trigger: expand all items
      this.collapseAll();
      // Remove is-final-item when globally expanding so CSS doesn't override margin-top
      if (this.finalItem) {
        this.finalItem.classList.remove('is-final-item');
      }
      this.items.forEach(i => this.expandItem(i));
    }

    handleIconLinkClick(e, iconLinkElement) {
      e.preventDefault();
      e.stopPropagation();

      const iconLink = iconLinkElement.getAttribute('data-icon-link');

      if (iconLink) {
        window.location.assign(iconLink);
      }
    }

    handleContentClick(e, item) {
      e.preventDefault();
      
      // Click on content: collapse all except final item (return to stacked state)
      if (this.finalItem) {
        this.finalItem.classList.add('is-final-item');
      }
      this.items.forEach(i => {
        if (i === this.finalItem) {
          this.expandItem(i);
        } else {
          this.collapseItem(i);
        }
      });
    }

    expandItem(item) {
      if (!item) return;

      const trigger = item.querySelector('.accordion-stack-2026__trigger');
      const content = item.querySelector('[data-accordion-content]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'true');
      }
      item.classList.add('is-expanded');

      if (content) {
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    }

    collapseItem(item) {
      if (!item || item === this.finalItem) return;

      const trigger = item.querySelector('.accordion-stack-2026__trigger');
      const content = item.querySelector('[data-accordion-content]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      item.classList.remove('is-expanded');

      if (content) {
        content.style.maxHeight = '0px';
      }
    }

    collapseAll() {
      this.items.forEach((item) => {
        if (item === this.finalItem) return; // Never collapse final item
        
        const trigger = item.querySelector('.accordion-stack-2026__trigger');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
        item.classList.remove('is-expanded');

        const content = item.querySelector('[data-accordion-content]');
        if (content) {
          content.style.maxHeight = '0px';
        }
      });
      // Restore is-final-item class when collapsing back to default state
      if (this.finalItem) {
        this.finalItem.classList.add('is-final-item');
      }
    }

    refreshExpandedHeights() {
      this.items.forEach((item) => {
        if (!item.classList.contains('is-expanded')) return;

        const content = item.querySelector('[data-accordion-content]');
        if (content) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    }

    bindImageLoadAdjustments() {
      const images = this.section.querySelectorAll('.accordion-stack-2026__content img');
      images.forEach((img) => {
        img.addEventListener('load', () => this.refreshExpandedHeights());
      });
    }
  }

  // Initialize on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.accordion-stack-2026');
    sections.forEach(section => {
      new AccordionStack(section);
    });
  });

  // Handle dynamic section loading (for Shopify theme customization)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      const section = e.detail.target;
      if (section && section.classList.contains('accordion-stack-2026')) {
        new AccordionStack(section);
      }
    });
  }
})();
